import { Component, EventEmitter, State, h, Event } from '@stencil/core';
import { TranslationValues } from '../../../models/ITranslationValues';
import { Translations } from '../../../helpers/TranslationUtils';
import { ApiCall } from '../../../helpers/ApiCall';
import { Citizenship } from '../../../models/ICitizenship';
import store from '../../../helpers/store';
import { FlowStatus } from '../../../models/FlowStatus';
import Events from '../../../helpers/Events';
import { EctData } from '../../../helpers/EctDb';

// @ts-ignore
import loaderImg from '../../../assets/loader.svg';
import logoOntrace from '../../../assets/logo-ontrace.svg';
import { delay } from '../../../utils/utils';
import { db } from '../../../helpers/db';

@Component({
  tag: 'citizenship-selection',
  styleUrl: 'citizenship-selection.css',
})
export class CitizenshipSelection {
  @State() private canCancel: boolean = true;
  @State() private selected: Citizenship = null;
  @State() private citizenships: Citizenship[] = [];
  @State() private imgClass: string = 'cit-selector';

  private ectData: EctData;

  @Event({
    eventName: 'apiError',
  })
  apiErrorEvent: EventEmitter<any>;

  private translations: TranslationValues;

  async componentWillLoad() {
    this.ectData = await db.ectdata.get(store.requestId);
  }

  async componentWillRender() {
    this.translations = await Translations.getValues();
    if (store.device.device.isDesktop) {
      this.imgClass = 'cit-selector-desktop';
    }

    if (!store.showCitizenshipSelector) {
      if (store.citizenship && store.citizenship != '') {
        await this.citizenshipSelected(store.citizenship);
      } else {
        store.flowStatus = await ApiCall.instance.GetNextFlowState();
      }
    } else {
      this.citizenships = await ApiCall.instance.GetCitizenshipList();
    }
  }

  private async doAction() {
    if (!this.canCancel) {
      return;
    }
    this.canCancel = false;

    try {
      let abortResult = await ApiCall.instance.AbortRequest();
      store.flowStatus = FlowStatus[abortResult.state];

      await db.ectdata.delete(store.requestId);

      Events.flowAborted();
    } catch (e) {
      Events.flowAborted();
      this.apiErrorEvent.emit(e);
    }
  }

  private async setCitizenship(citizenship: Citizenship) {
    this.selected = citizenship;
    this.citizenshipSelected(citizenship.name);
  }

  private async citizenshipSelected(citizenship: string) {
    if (!this.canCancel) {
      return;
    }
    this.canCancel = false;
    store.citizenship = citizenship;

    if (!this.ectData) {
      await delay(500);
      if (!this.ectData) this.ectData = await db.ectdata.get(store.requestId);
    }

    this.ectData.citizenship = citizenship;
    db.ectdata.put(this.ectData);

    try {
      await ApiCall.instance.SetCitizenship();
    } catch (e) {
      this.apiErrorEvent.emit(e);
    }
  }

  render() {
    return (
      <div class="container flex center">
        <div class="px-3">
          <h1 class="text-center">{this.translations.CitizenshipSelectionValues.Title}</h1>
          <p class="loud-text color-blue text-center">{this.translations.CitizenshipSelectionValues.Description}</p>

          <div class="py-1">
            {this.citizenships.map(citizenship => {
              return (
                <div class="d-flex center mb-1" onClick={() => this.setCitizenship(citizenship)}>
                  <h3>{citizenship.name}</h3>
                  <div class={this.imgClass + ' relative ml-1'}>
                    {this.selected?.name == citizenship.name ? (
                      <div class="img-loader rounded w-100 h-100 flex center">
                        <img class="loading-image" src={loaderImg}></img>
                      </div>
                    ) : null}
                    <img class="rounded d-block w-100" src={citizenship.image}></img>
                  </div>
                </div>
              );
            })}
          </div>

          <div class="text-center">
            <p class="main-text link-text" onClick={() => this.doAction()}>
              {this.translations.LandingValues.ButtonLeave}
            </p>
          </div>

          <div class="footer text-center">
            <img src={logoOntrace}></img>
          </div>
        </div>
      </div>
    );
  }
}
